import React from "react";

import { withStyles } from "@material-ui/core";
const styles = {
    
  };

const LiveFeed = props => {
  
  return (
    <video controls autoPlay={true} loop="" muted={true} data-reactid=".0.1.0.0">
      <source type="video/mp4" data-reactid=".0.1.0.0.0" src="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4" />
    </video>
  );
}


  
export default withStyles(styles)(LiveFeed);